'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getName = require('./get-name');
var convertDate = function convertDate(date) {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate(),
    hour: date.getHours(),
    minute: date.getMinutes(),
    second: date.getSeconds(),
    dayOfWeek: (0, _getName.getNamedDay)(date.getDay())
  };
};
exports.default = convertDate;